import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
const included = ['5 volumes pédagogiques de 60 pages', '4 ressources complémentaires (160 pages)', '460 pages de ressources pédagogiques', 'Schémas, fiches visuelles, séquences et activités', 'Évaluations, barèmes et corrigés', 'Parcours de différenciation et de remédiation', 'Accès numérique immédiat · Accès à vie'];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-white px-5 py-8 sm:py-12" data-id="element-218" data-mp="2mxam65b9f14w">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[600px]" data-id="element-219" data-mp="2965v3rlyjh66">
        <h2 className="text-center font-serif-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-220" data-mp="35p3fy1y5kqdo">
          Accédez à la bibliothèque complète CHIMIE VISUELLE™
        </h2>
        <p className="mt-2 text-center text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-221" data-mp="1tfmrgz45k987">
          Un seul accès pour l’ensemble des ressources, disponibles immédiatement.
        </p>

        <div className="mt-5 rounded-2xl border border-cobalt/25 p-4 sm:mt-8 sm:p-6" data-id="element-222" data-mp="235y192aipcn0">
          <ul className="space-y-2.5" data-id="element-223" data-mp="1ydeou8nkgnjs">
            {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-224" data-mp="2c5bd21m46daw">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-225" data-mp="2c7pagh49o1lm">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-226" data-mp="2m4af31cdjaox" />
                </span>
                <span className="text-[13px] leading-snug text-ink/80 sm:text-sm" data-id="element-227" data-mp="2h4fkonte42z4">{item}</span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-cobalt/30" data-id="element-228" data-mp="rq9hejsk8tqf" />

          <div className="flex flex-col items-center rounded-xl bg-cobalt/10 py-5 text-center sm:py-6" data-id="element-229" data-mp="mrpuag28dbwh">
            <span className="text-[13px] font-medium text-ink/70 sm:text-sm" data-id="element-230" data-mp="2mtxn9wx4hsfn">
              Valeur des ressources à l’unité : 109 €
            </span>
            <span className="mt-3 text-sm font-medium text-cobalt-deep" data-id="element-231" data-mp="2ru3mpz9mwj8a">Accès complet</span>
            <span className="font-serif-display text-5xl font-bold text-cobalt sm:text-6xl" data-id="element-232" data-mp="2vvym2y808mjf">
              19 €
            </span>
            <p className="mt-2 px-4 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-233" data-mp="35s9yrpbibeee">
              Paiement unique — Aucun abonnement
            </p>
            <p className="mt-1 px-4 text-xs text-ink/60 sm:text-sm" data-id="element-234" data-mp="3apjxxwop74ff">
              Accès envoyé par e-mail juste après le paiement
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-235" data-mp="3jjonmcs3i9td">
          <div className="mb-6 flex flex-col items-center text-center sm:mb-8" data-id="element-236" data-mp="3jlj6lljt3rut">
            <span className="text-xs font-bold uppercase tracking-widest text-cobalt-deep" data-id="element-237" data-mp="3ok2tbo6857o8">
              Un aperçu de la bibliothèque
            </span>
            <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-238" data-mp="7fvpe61439ml">
              À l’intérieur de <span className="text-cobalt" data-id="element-239" data-mp="2g0vdtm1i3xb">CHIMIE VISUELLE™</span>
            </h3>
            <p className="mt-2 text-sm font-medium text-ink/70 sm:text-base" data-id="element-240" data-mp="3tmtvsv90dz0s">
              Schémas, fiches visuelles, activités et évaluations déjà classés par notion et prêts à
              imprimer ou à projeter.
            </p>

            <div className="mt-5 w-full overflow-hidden rounded-xl border border-cobalt/20 bg-paper shadow-sm sm:mt-6" data-id="element-241" data-mp="q64zs371y7pd">
              <video src="https://cdn.magicpatterns.com/uploads/mpZS7KZthWW9e554TjorGG/CHIMIE_VISUELLE_LANDING_MOBILE_OPTIMIZED.mp4" autoPlay loop muted playsInline className="aspect-video w-full object-cover" data-id="element-242" data-mp="l9mw76ngkfem" />
            </div>
          </div>

          <CTAButton label="OBTENIR MON ACCÈS À CHIMIE VISUELLE™" href={CHECKOUT_URL} external data-id="element-243" data-mp="145d1b2qotrwq" />
          <p className="mt-2.5 text-center text-xs text-ink/60 sm:text-sm" data-id="element-244" data-mp="oo4wo7fo6hhx">
            Paiement unique • Aucun abonnement • Accès numérique • Accès à vie
          </p>

          <div className="mt-4 rounded-xl border border-cobalt/20 bg-cobalt/5 px-4 py-3 text-center" data-id="element-245" data-mp="fnq3klwgry3v">
            <p className="text-sm font-bold text-cobalt-deep" data-id="element-246" data-mp="jp1ssqbfehbj">Paiement sécurisé</p>
            <p className="mt-1 text-xs leading-relaxed text-ink/70 sm:text-sm" data-id="element-247" data-mp="jr4rdyqn9irv">
              Les principales cartes bancaires sont acceptées. Le paiement de 19 € est traité de
              manière sécurisée.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}